export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_03.4845708f.mp4";